

















import Vue from 'vue'
import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'
import { defineComponentTranslations } from '~/utils/i18n'

export default Vue.extend({
  i18n: defineComponentTranslations({
    category_fieldset_sub: {
      en: 'What do you want to list?',
      el: 'Τι θες να καταχωρίσεις;'
    }
  }),
  components: { Fieldset },
  mixins: [BaseFieldsetMixin]
})
